import { Link, Stack, Typography } from "@mui/material";
import { DateTime } from "luxon";
import {
  ActionItemStatusPropertyChange,
  ContextPropertyChange,
  DecisionMakerPropertyChange,
  DescriptionPropertyChange,
  DueDatePropertyChange,
  IssueCollaboratorsPropertyChange,
  IssueStatusPropertyChange,
  MetricDatapointPropertyChange,
  MetricDatasetPropertyChange,
  MetricDescriptionPropertyChange,
  MetricTitlePropertyChange,
  NotePropertyChange,
  OwnershipPropertyChange,
  ProposalPropertyChange,
  RoleAccountabilityPropertyChange,
  RoleDescriptionPropertyChange,
  RoleNamePropertyChange,
  RoleTeamPropertyChange,
  RoleUserPropertyChange,
  SelectedProposalPropertyChange,
  TagsPropertyChange,
  TaskItemParentPropertyChange,
  TaskItemStatusPropertyChange,
  TeamNamePropertyChange,
  TeamParentPropertyChange,
  TeamPurposePropertyChange,
  TeamSlugPropertyChange,
} from ".";
import { FeedItemProperty, Links } from "../../constants";
import { FeedItemDto } from "../../http";

interface IProps {
  feedItem: FeedItemDto;
}

const FeedPropertyChange = (props: IProps) => {
  function renderPropertyChange() {
    switch (props.feedItem.propertyChange!.propertyName) {
      case FeedItemProperty.ActionItemStatus:
        return <ActionItemStatusPropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.Context:
        return <ContextPropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.DecisionMaker:
        return <DecisionMakerPropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.Description:
        return <DescriptionPropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.DueDate:
        return <DueDatePropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.IssueCollaborators:
        return <IssueCollaboratorsPropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.IssueStatus:
        return <IssueStatusPropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.MetricDatapoint:
        return <MetricDatapointPropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.MetricDataset:
        return <MetricDatasetPropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.MetricDescription:
        return <MetricDescriptionPropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.MetricTitle:
        return <MetricTitlePropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.Note:
        return <NotePropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.Ownership:
        return <OwnershipPropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.Proposal:
        return <ProposalPropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.RoleAccountability:
        return <RoleAccountabilityPropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.RoleDescription:
        return <RoleDescriptionPropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.RoleName:
        return <RoleNamePropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.RoleTeam:
        return <RoleTeamPropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.RoleUser:
        return <RoleUserPropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.SelectedProposal:
        return <SelectedProposalPropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.Tags:
        return <TagsPropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.TaskItemParent:
        return <TaskItemParentPropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.TaskItemStatus:
        return <TaskItemStatusPropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.TeamName:
        return <TeamNamePropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.TeamParent:
        return <TeamParentPropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.TeamPurpose:
        return <TeamPurposePropertyChange feedItem={props.feedItem} />;
      case FeedItemProperty.TeamSlug:
        return <TeamSlugPropertyChange feedItem={props.feedItem} />;
      default:
        return (
          <Typography variant="caption">
            <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
            <span> updated </span>
            {props.feedItem.propertyChange!.propertyName}
          </Typography>
        );
    }
  }

  const propertyChange = renderPropertyChange();

  if (propertyChange == null) {
    return null;
  } else {
    return (
      <Stack
        direction="row"
        spacing={0.25}
        sx={{ backgroundColor: "rgba(0, 0, 0, 0.03)", px: { xs: 0.5, sm: 1 }, py: 0.5 }}
      >
        <Typography variant="caption">&bull;</Typography>
        <Stack direction="column">
          <Typography variant="caption">
            {DateTime.fromISO(props.feedItem.timestampUtc, { zone: "utc" })
              .toLocal()
              .toLocaleString(DateTime.DATETIME_MED)}
          </Typography>
          {propertyChange}
        </Stack>
      </Stack>
    );
  }
};

export { FeedPropertyChange };
